import React from 'react';
import PropTypes from 'prop-types';

export default function Modal({
  title, content, onClose, editItem,
}) {
  return (
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
      <div className="bg-private p-5 dark:bg-gray-800 relative shadow-md w-1/2 rounded">
        <button
          className="float-right text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
          type="button"
          onClick={onClose}
        >
          x
        </button>
        <h2 className="text-xl text-gray-100 font-extrabold py-4">
          {title}
        </h2>
        <div>
          {React.cloneElement(content, { editItem })}
        </div>
      </div>
    </div>
  );
}

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  editItem: PropTypes.object,
};

Modal.defaultProps = {
  editItem: null,
};
